var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_348_2655)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6353 15.1861C12.8566 15.3381 13.1419 15.3761 13.3962 15.2828C13.6504 15.1888 13.8374 14.9781 13.8937 14.7228C14.491 12.0001 15.9398 5.10877 16.4834 2.6321C16.5247 2.44543 16.4559 2.25143 16.3047 2.12677C16.1535 2.0021 15.9439 1.9661 15.757 2.03343C12.8752 3.0681 4.00027 6.2981 0.372782 7.6001C0.142541 7.68276 -0.0072867 7.89743 0.000273439 8.13277C0.00852086 8.36877 0.172095 8.57343 0.407834 8.6421C2.03464 9.1141 4.17003 9.77076 4.17003 9.77076C4.17003 9.77076 5.16797 12.6941 5.68825 14.1808C5.75354 14.3674 5.90405 14.5141 6.10268 14.5648C6.30062 14.6148 6.5123 14.5621 6.66007 14.4268C7.49581 13.6614 8.7879 12.4781 8.7879 12.4781C8.7879 12.4781 11.2429 14.2241 12.6353 15.1861ZM5.06831 9.40143L6.22227 13.0934L6.47862 10.7554C6.47862 10.7554 10.937 6.85477 13.4786 4.63143C13.5529 4.5661 13.5632 4.45677 13.5013 4.3801C13.4401 4.30343 13.3274 4.28543 13.2429 4.33743C10.2972 6.1621 5.06831 9.40143 5.06831 9.40143Z",
    fill: "#28A7E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_348_2655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4948,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.772388fa9d10159f0928d60c01566a00.svg";
export { ForwardRef as ReactComponent };